"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const constants_1 = require("../../constants");
const gql_1 = require("../gql");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix = ({ productTreeNodeId, options, }) => {
    const { data, error, networkStatus } = (0, react_2.useQuery)(gql_1.GET_ALL_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX, Object.assign({ variables: {
            productTreeNodeId,
            filter: constants_1.DEFAULT_DESCENDANTS_FILTER_STRATEGY_MATRIX,
            first: client_constants_1.REQUEST_LIMIT_MEDIUM, // infinity loading???
            sort: [{ title: graphql_1.SortOrder.Asc }],
        }, skip: !productTreeNodeId || (options === null || options === void 0 ? void 0 : options.skip) }, options));
    const categories = (0, react_1.useMemo)(() => { var _a, _b; return (_b = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []; }, [data]);
    return {
        data: categories,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        error: error === null || error === void 0 ? void 0 : error.message,
    };
};
exports.useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix = useGetAllL1CategoriesAndTerminalNodesForStrategyMatrix;
